const heroSlider = document.querySelector(".sh-hero-slider");
const featuredCollection = document.querySelector('.sh-featured-slider')

if (heroSlider) {
  new Splide(heroSlider,{
    type: 'loop',
    focus: 'center',
    pagination: false,
    autoHeight: true,
    autoplay: true,
    inerval: 10000
  }).mount();
}

if (featuredCollection) {
  new Splide(featuredCollection,{
    perPage: 3,
    gap:30,
    pagination: false,
    breakpoints: {
    800: {
      perPage: 2,
    },
    600: {
      perPage: 1,
    }
  },
  }).mount();
}